// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"style_searchSection__B5wnF","title":"style_title__mjt9X","userDetails":"style_userDetails__QB0hG","table":"style_table__27uX9"};